export const errorHandling = {
  props: {
    errors: [Object, null],
  },

  methods: {
    hasErrorsByKey (key) {
      if (!this.errors) {
        return false;
      }

      return this.errors[key] ? true : false;
    },

    getErrorsByKey (key) {
      if (!this.errors) {
        return [];
      }

      return this.errors[key];
    },
  },
};
